import { GlButton } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { TYPE_ISSUE } from '~/issues/constants';
import AssigneeAvatar from './assignee_avatar.vue?vue3';
import UserNameWithStatus from './user_name_with_status.vue?vue3';
export default {
    name: 'CollapsedAssignee',
    components: {
        GlButton,
        AssigneeAvatar,
        UserNameWithStatus
    },
    props: {
        user: {
            type: Object,
            required: true
        },
        issuableType: {
            type: String,
            required: false,
            default: TYPE_ISSUE
        }
    },
    computed: {
        availability () {
            return this.user?.availability || '';
        }
    }
};
